module.exports = __webpack_public_path__ + "assets/img/head.b7165992.svg";